module.exports = __webpack_public_path__ + "img/vertical_6_3_9016.004c39bf.png";